import React from 'react';
import bn from "../../utils/bemnames";
import ComponentWrapper from "../MatchCenter/ComponentWrapper";
import {_t} from "../../utils/translations";

interface IProps {
  componentName: string | undefined
}

const bem = bn.create('empty-component');

const EmptyComponent:React.FC<IProps> = ({ componentName }) => (
  <ComponentWrapper
    children={(
      <div className={bem.b()}>{_t('Not Available')}</div>
    )}
    title={_t(componentName as string)} />
)

export default EmptyComponent;
